import React from 'react';
import { StyledTemplateTable } from './Template.styles';
import TemplateTable from './TemplateTable';

export default function TemplateTableWrapper({ columns, data, onRowSelected, rowSelection }: any) {
    return (
        <StyledTemplateTable>
            <TemplateTable 
                columns={columns} 
                data={data} 
                onRowSelected={onRowSelected}
                rowSelection={rowSelection}
            />
        </StyledTemplateTable>
    )
}